/** @format */

import React, { useEffect, useState } from "react";
import { TailSpin } from "react-loader-spinner";

type newsLetterProps = {
  status: string | null;
  message: string | Error | null;
  onValidated: React.Dispatch<void | React.SetStateAction<{
    MERGE0: string;
    MERGE1: string;
  }>>;
};

const initialValues = {
  firstName: "",
  email: "",
};

const NewsLetter = ({ status, message, onValidated }: newsLetterProps) => {
  const [values, setValues] = useState(initialValues);

  const onChangeHandler = (e: {
    currentTarget: { name: any; value: any };
  }): void => {
    const { name, value } = e.currentTarget;
    setValues({
      ...values,
      [name]: value,
    });
  };

  useEffect(() => {
    if (status === "success") clearFields();
  }, [status]);

  const clearFields = () => {
    setValues(initialValues);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    values.email &&
      values.firstName &&
      values.email.indexOf("@") > -1 &&
      onValidated({
        MERGE0: values.email,
        MERGE1: values.firstName,
      });
  };
  return (
    <div className="pb-[87px]">
      <div className="flex flex-col justify-center items-center">
        <form onSubmit={(e) => handleSubmit(e)}>
          <h1 className="font-semibold lg:text-[40px] text-[25px] lg:leading-[54.56px] leading-[35px] tracking-[-2%] text-white mt-[40px] text-center">
            {status === "success"
              ? "Thanks for signing up to the FitStats newsletter"
              : "SUBSCRIBE TO OUR NEWSLETTER"}
          </h1>
          {status === "error" && (
            <span className="text-white text-center">
              {message?.toString()}
            </span>
          )}
          <div className="flex md:flex-row flex-col mt-[71px] w-full">
            <input
              style={{ width: "100%" }}
              onChange={onChangeHandler}
              type="text"
              value={values.firstName}
              placeholder="Enter your name here "
              name="firstName"
              className="bg-transparent border md:border-r-0 md:border-b border-b-0 border-white py-[17px] sm:pr-[110px] sm:pl-[30px] pl-[30px] pr-[30px] m-auto sm:text-left text-center text-white rounded-none md:w-auto w-full"
              required={true}
            />
            <input
              style={{ width: "100%" }}
              onChange={onChangeHandler}
              type="email"
              value={values.email}
              placeholder="Enter your mail here "
              name="email"
              className="bg-transparent border border-l border-white py-[17px] sm:pr-[110px] sm:pl-[30px] pl-[30px] pr-[30px] m-auto sm:text-left text-center text-white rounded-none md:w-auto w-full"
            />
            <button
              type="submit"
              className={` py-[17px] text-[#121212] text-[18px] leading-[24.55px] md:px-[40px] px-10 md:w-auto  ${
                values.email && values.firstName
                  ? "cursor-pointer bg-white"
                  : "bg-[#EBEBE4]"
              }`}
              disabled={values.email && values.firstName ? false : true}
            >
              {status === "sending" ? (
                <div className="flex justify-center items-center">
                  <TailSpin
                    height="25"
                    width="25"
                    color="purple"
                    ariaLabel="tail-spin-loading"
                    radius="1"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                  />
                </div>
              ) : (
                <div className="flex justify-center items-center">
                  Subscribe
                </div>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewsLetter;
